import { AUTHORIZATION_HEADER } from '../../../src/authorization';
import { send } from '../../../src/network';

type Params = {
  orderId: number;
  consented?: boolean;
};

export async function placeCheckoutOrder({
  orderId: order_id,
  consented,
}: Params) {
  return send<{ [key: string]: string }>({
    path: '/api/place_checkout_order/',
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
    body: { order_id, consented },
  });
}
